// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","slideButton":"slide-button_slideButton__GCM02","next":"slide-button_next__LRtt0","prev":"slide-button_prev__a+KtG"};